import { Inbox } from 'lucide-react';
import type { NavItem } from './types';

/**
 * Destino «Recepción» (§4.12), vista 24 (`/inbound`). La vista 25
 * (`/inbound/:id`) has no entry of its own: it is reached from a row of view
 * 24, never from the menu.
 *
 * The counter §4.12 asks for (`inboundPending`: DTEs received and not
 * acknowledged) is NOT filled here and cannot be: this file is a static array
 * and the count comes from a hook. `AppLayout` attaches it onto this tree, via
 * `nav/use-nav-badges.ts`.
 */
export const inboundNav: readonly NavItem[] = [
  {
    label: 'Recepción',
    to: '/inbound',
    icon: Inbox,
    group: 'operation',
    minimumPhase: 'in-certification',
  },
];
